import { validateEmail } from "../utils/validation";
export function toWireChannel(channel) {
    return channel === "email" ? "email" : "whatsapp";
}
export const MIN_PHONE_LENGTH = 7;
export function isValidOtpDestination(channel, value) {
    if (channel === "email")
        return validateEmail((value.email ?? "").trim());
    return Boolean(value.countryCode &&
        value.phoneNumber &&
        value.phoneNumber.length >= MIN_PHONE_LENGTH);
}
export function otpDestinationError(channel) {
    return channel === "email"
        ? "Please enter a valid email address"
        : "Please enter a valid phone number";
}
export function otpDestinationErrorKey(channel) {
    return channel === "email" ? "errorInvalidEmail" : "errorInvalidPhone";
}
export function formatOtpDestination(channel, value) {
    return channel === "email"
        ? (value.email ?? "")
        : `${value.countryCode ?? ""} ${value.phoneNumber ?? ""}`.trim();
}
